"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _Button = require("../Button/Button");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _UploadSource = require("./UploadSource.styled");
var UploadSourceFooter = function UploadSourceFooter(_ref) {
  var disabled = _ref.disabled,
    onCancel = _ref.onCancel,
    createButtonText = _ref.createButtonText;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "float-end"
  }, /*#__PURE__*/_react["default"].createElement(_Button.Button, {
    "data-testid": "createButton",
    disabled: disabled
  }, createButtonText), ' ', /*#__PURE__*/_react["default"].createElement(_UploadSource.StyledCancelButton, {
    "data-testid": "cancelButton",
    color: "light",
    variant: "outlined",
    onClick: function onClick(e) {
      e.preventDefault();
      onCancel();
    }
  }, "Cancel"));
};
UploadSourceFooter.propTypes = {
  onCancel: _propTypes["default"].func.isRequired,
  disabled: _propTypes["default"].bool.isRequired,
  createButtonText: _propTypes["default"].string.isRequired
};
var _default = exports["default"] = UploadSourceFooter;